"use strict";



/*********************************************************
common start
*********************************************************/
var controller = new ScrollMagic.Controller();
var tl = new TimelineMax();



$(function() {

  /*********************************************************
  common accordion start
  *********************************************************/
  function accordionAll() {
    $(this).toggleClass("active").next().slideToggle();
  }
  $(".acc-toggle").click(accordionAll);
  /*********************************************************
  common accordion end
  *********************************************************/

/*********************************************************
common menu start
*********************************************************/
  if($('#menu-toggle').length){
    $('#menu-toggle').on('click', function() {
      $(this).addClass('open');
      $('.sp-main-navigation').addClass('open');
      $('#sp-menu-toggle').addClass('open');
      return false;
    })
  }

  if($('#sp-menu-toggle').length){
    $('#sp-menu-toggle').on('click', function() {
      $(this).removeClass('open');
      $('.sp-main-navigation').removeClass('open');
      $('#menu-toggle').removeClass('open');
      return false;
    })
  }

/*********************************************************
common menu start
*********************************************************/

  /*********************************************************
  common animation start
  *********************************************************/
  if($('.slideLeft').length){
    $(".slideLeft").each(function() {
      var tl = new TimelineMax();
      tl.fromTo(this, 1, {
        autoKill: false,
      }, {
        autoKill: false,
        className: "+=slideLeft-on",
      });

      new ScrollMagic.Scene({
          triggerElement: this,
          duration:400,
          reverse: false,
          triggerHook: .85
        })
        .setTween(tl).addTo(controller)
      //.addIndicators();
    });
  }
  if($('.slideRight').length){
    $(".slideRight").each(function() {
      var tl = new TimelineMax();
      tl.fromTo(this, 1, {
        autoKill: false,
      }, {
        autoKill: false,
        className: "+=slideRight-on",
      });

      new ScrollMagic.Scene({
          triggerElement: this,
          duration:400,
          reverse: false,
          triggerHook: .85
        })
        .setTween(tl).addTo(controller)
      //.addIndicators();
    });
  }
  if($('.bg-cover').length){
    $(".bg-cover").each(function() {
      var tl = new TimelineMax();
      tl.fromTo(this, 1, {
        autoKill: false,
      }, {
        autoKill: false,
        className: "+=bg-cover-active",
        onComplete: function() {
        }, //callback
      });

      new ScrollMagic.Scene({
          triggerElement: this,
          duration: 400,
          offset: 0,
          reverse: false,
          triggerHook: .85
        })
        .setTween(tl).addTo(controller)
      //.addIndicators();
    });
  }

  if($('.slideUp').length){
    $(".slideUp").each(function() {
      var tl = new TimelineMax();
      tl.fromTo(this, 1, {
        autoKill: false,
      }, {
        autoKill: false,
        className: "+=slideUp-on",
      });

      new ScrollMagic.Scene({
          triggerElement: this,
          duration:400,
          reverse: false,
          triggerHook: .85
        })
        .setTween(tl).addTo(controller)
      //.addIndicators();
    });
  }
  if($('.fadeUp').length){
      $(".fadeUp").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=fadeUp-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
            triggerHook: .85
          })
          .setTween(tl).addTo(controller)
      });
  }
  if($('.scaleUp').length){
      $(".scaleUp").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=scaleUp-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
            triggerHook: .85
          })
          .setTween(tl).addTo(controller)
      });
  }
  if($('.scaleUp2').length){
      $(".scaleUp2").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=scaleUp-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
            triggerHook: .85
          })
          .setTween(tl).addTo(controller)
      });
  }
  if($('.slideFill').length){
      $(".slideFill").each(function() {
        var tl = new TimelineMax();
        tl.fromTo(this, 1, {
          autoKill: false,
        }, {
          autoKill: false,
          className: "+=slideFill-on",
        });
        new ScrollMagic.Scene({
            triggerElement: this,
            duration:400,
            reverse: false,
            triggerHook: .85
          })
          .setTween(tl).addTo(controller)
      });
  }
  /*********************************************************
  common animation end
  *********************************************************/

  /*********************************************************
  common pagetop start
  *********************************************************/
    var topBtn = $('#pagetop');
    topBtn.on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
  /*********************************************************
  common pagetop end
  *********************************************************/


});
/*********************************************************
common end
*********************************************************/
